import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";
import ModalDeleteUserRole from "./ModalDeleteUserRole";
import ShortNotification from "../../../components/Toast/ShortNotification";

export default function AdminUserRoles(props) {
  const [openModal, SetopenModal] = useState({
    is_open: false,
    data: {},
  });
  const [openToast, SetOpenToast] = useState(false);
  const [toastData, SetToastData] = useState({ message: "", style: "" });
  //
  const [id_value, SerIdValue] = useState(useParams());
  const [brand_active_roles, SetBrandActiveRoles] = useState([]);
  const [outlet_active_roles, SetOutletActiveRoles] = useState([]);

  useEffect(() => {
    console.log("AdminUserRoles On mount :", props);
    get_custom_roles();
  }, []);

  function ModalOnClose(data) {
    SetopenModal({
      is_open: false,
      data: {},
    });
    // SetToastData({ message: "User Role Deleted", style: "" });
    // SetOpenToast(true);
    if (data.action == "delete") {
      console.log("on confirm delete :", data.value);
      delete_role(
        data.value.element,
        data.value.index,
        data.value.type,
        data.value.status
      );
    }
  }

  function ToastOnClose(data) {
    SetOpenToast(false);
  }
  //

  async function get_custom_roles() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
    };
    let data = await api("/brand/get_custom_roles", pass_data);
    console.log("get_custom_roles response :", data);
    if (data.status_code == 200) {
      data.response.roles.map((role_element, role_index) => {
        if (role_element.name == "Brand") {
          if (role_element.hasOwnProperty("roles")) {
            SetBrandActiveRoles(role_element.roles);
          } else {
            SetBrandActiveRoles([]);
          }
        } else if (role_element.name == "Outlet") {
          if (role_element.hasOwnProperty("roles")) {
            SetOutletActiveRoles(role_element.roles);
          } else {
            SetOutletActiveRoles([]);
          }
        }
      });
    }
  }

  function view_role(ele, index, type, status) {
    console.log("View Role");
    console.log("View Role ele :", ele);
    console.log("View Role index :", index);
    console.log("View Role type :", type);
    console.log("View Role status :", status);
  }
  function edit_role(ele, index, type, status) {
    console.log("Edit Role");
    console.log("Edit Role ele :", ele);
    console.log("Edit Role index :", index);
    console.log("Edit Role type :", type);
    console.log("Edit Role status :", status);
  }
  async function delete_role(ele, index, type, status) {
    console.log("Delete Role");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
      post: {
        role_id: ele.id,
      },
    };
    let data = await api("/brand/delete_custom_user_role", pass_data);
    console.log("delete_custom_user_role response :", data);
    if (data.status_code == 200) {
      get_custom_roles();
    }
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4">
        <h5 className="  mb-1 text-dark fw-bolder">User Roles</h5>
        <p className="mb-0 v-small">Brands & Outlets</p>
      </div>
      <div className="container-fuild mt-3 p-3">
        <div className="row">
          <div className="col-lg-6 mb-3">
            <div className="box-3 p-3 br-3 ">
              <div className="d-flex align-items-center mb-3">
                <h6 className="mb-0">Brand User Roles</h6>
                <Link
                  to="add/brand/new"
                  className="btn-light-outline d-flex align-items-center text-dark cursor py-1 px-2 ms-auto"
                >
                  <img src={require("../../../assets/icon/svg/plus1.svg")} className=" pe-2" /> Add
                </Link>
              </div>
              <div>
                {brand_active_roles.length > 0 ? (
                  <table className="table mt-2">
                    <tbody>
                      {brand_active_roles.map((ele, index) => (
                        <tr key={index}>
                          <td>{ele.name}</td>
                          <td>
                            <div className="d-flex">
                              <img src={require("../../../assets/icon/svg/user1.svg")} className="action_menu_img me-1" />
                              {ele.created_user}
                            </div>
                          </td>

                          <td className="cursor">
                            <div className="dropdown">
                              <div
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/more-horizontal.svg")}
                                  className="action_img cursor"
                                />
                              </div>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                    <Link
                                      className="cursor dropdown-item"
                                      to={
                                        "/brand/" +
                                        id_value.brand_id +
                                        "/userroles/view/brand/" +
                                        ele.id
                                      }
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/eye.svg")}
                                        className="action_menu_img cursor"
                                      />
                                      &nbsp; View
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                      className="cursor dropdown-item"
                                      to={
                                        "/brand/" +
                                        id_value.brand_id +
                                        "/userroles/edit/brand/" +
                                        ele.id
                                      }
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/edit-3.svg")}
                                        className="action_menu_img cursor"
                                      />
                                      &nbsp; Edit
                                    </Link>
                                </li>
                                <li>
                                    <div
                                      className="cursor dropdown-item"
                                      onClick={() => {
                                        SetopenModal({
                                          is_open: true,
                                          data: {
                                            element: ele,
                                            index: index,
                                            type: "brand",
                                            status: "active",
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/trash-2.svg")}
                                        className="action_menu_img cursor"
                                      />
                                      &nbsp; Delete
                                    </div>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center">
                    <img src={require("../../../assets/img/svg/no_data_2.svg")} className="w-30 pb-2" />
                    <p className="v-small mb-0">No Data, Please Add Some Roles</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-3">
            <div className="box-3 p-3 br-3 ">
              <div className="d-flex align-items-center mb-3">
                <h6 className="mb-0">Outlet User Roles</h6>
                <Link
                  to="add/outlet/new"
                  className="btn-light-outline d-flex align-items-center text-dark cursor py-1 px-2 ms-auto"
                >
                  <img src={require("../../../assets/icon/svg/plus1.svg")} className=" pe-2" /> Add
                </Link>
              </div>

              <div>
                {outlet_active_roles.length > 0 ? (
                  <table className="table">
                    <tbody>
                      {outlet_active_roles.map((ele, index) => (
                        <tr key={index}>
                          <td>{ele.name}</td>
                          <td>
                            <div className="d-flex">
                              <img src={require("../../../assets/icon/svg/user1.svg")} className="action_menu_img me-1" />
                              {ele.created_user}
                            </div>
                          </td>
                          <td className="cursor">
                            <div className="dropdown">
                              <div
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <img
                                  src={require("../../../assets/icon/svg/more-horizontal.svg")}
                                  className="action_img cursor"
                                />
                              </div>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                              >
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <Link
                                      className="cursor"
                                      to={
                                        "/brand/" +
                                        id_value.brand_id +
                                        "/userroles/view/outlet/" +
                                        ele.id
                                      }
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/eye.svg")}
                                        className="action_menu_img cursor"
                                      />
                                      &nbsp; View
                                    </Link>
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <Link
                                      className="cursor"
                                      to={
                                        "/brand/" +
                                        id_value.brand_id +
                                        "/userroles/edit/outlet/" +
                                        ele.id
                                      }
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/edit-3.svg")}
                                        className="action_menu_img cursor"
                                      />
                                      &nbsp; Edit
                                    </Link>
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <div
                                      className="cursor"
                                      onClick={() => {
                                        SetopenModal({
                                          is_open: true,
                                          data: {
                                            element: ele,
                                            index: index,
                                            type: "outlet",
                                            status: "active",
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={require("../../../assets/icon/svg/trash-2.svg")}
                                        className="action_menu_img cursor"
                                      />
                                      &nbsp; Delete
                                    </div>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center">
                    <img src={require("../../../assets/img/svg/no_data_2.svg")} className="w-30 pb-2" />
                    <p className="v-small mb-0">No Data, Please Add Some Roles</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <ModalDeleteUserRole
          open={openModal.is_open}
          data={openModal.data}
          close={ModalOnClose}
        />
        <ShortNotification
          open={openToast}
          close={ToastOnClose}
          data={toastData}
        />
      </div>
    </div>
  );
}
